export default "<p>assets-summary works!</p>\n"